import CategoryProductOptionProduct from './CategoryProductOptionProduct'

export default CategoryProductOptionProduct
